import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';
import { createEntity, getEntity, reset, updateEntity } from './country-of-birth.reducer';

export const CountryOfBirthUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const countryOfBirthEntity = useAppSelector(state => state.countryOfBirth.entity);
  const loading = useAppSelector(state => state.countryOfBirth.loading);
  const updating = useAppSelector(state => state.countryOfBirth.updating);
  const updateSuccess = useAppSelector(state => state.countryOfBirth.updateSuccess);
  const geographicLevelValues = Object.keys(GeographicLevel);

  const handleClose = () => {
    navigate(`/country-of-birth${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAllUsualResidents !== undefined && typeof values.totalAllUsualResidents !== 'number') {
      values.totalAllUsualResidents = Number(values.totalAllUsualResidents);
    }
    if (values.ukTotal !== undefined && typeof values.ukTotal !== 'number') {
      values.ukTotal = Number(values.ukTotal);
    }
    if (values.england !== undefined && typeof values.england !== 'number') {
      values.england = Number(values.england);
    }
    if (values.northernIreland !== undefined && typeof values.northernIreland !== 'number') {
      values.northernIreland = Number(values.northernIreland);
    }
    if (values.scotland !== undefined && typeof values.scotland !== 'number') {
      values.scotland = Number(values.scotland);
    }
    if (values.wales !== undefined && typeof values.wales !== 'number') {
      values.wales = Number(values.wales);
    }
    if (values.republicOfIreland !== undefined && typeof values.republicOfIreland !== 'number') {
      values.republicOfIreland = Number(values.republicOfIreland);
    }
    if (values.otherEuCountries !== undefined && typeof values.otherEuCountries !== 'number') {
      values.otherEuCountries = Number(values.otherEuCountries);
    }
    if (values.africa !== undefined && typeof values.africa !== 'number') {
      values.africa = Number(values.africa);
    }
    if (values.middleEastAsia !== undefined && typeof values.middleEastAsia !== 'number') {
      values.middleEastAsia = Number(values.middleEastAsia);
    }
    if (values.farEast !== undefined && typeof values.farEast !== 'number') {
      values.farEast = Number(values.farEast);
    }
    if (values.theAmericas !== undefined && typeof values.theAmericas !== 'number') {
      values.theAmericas = Number(values.theAmericas);
    }
    if (values.antarcticaOceania !== undefined && typeof values.antarcticaOceania !== 'number') {
      values.antarcticaOceania = Number(values.antarcticaOceania);
    }
    if (values.otherCountries !== undefined && typeof values.otherCountries !== 'number') {
      values.otherCountries = Number(values.otherCountries);
    }

    const entity = {
      ...countryOfBirthEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          geographicLevel: 'EXTRA_WARD',
          ...countryOfBirthEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="apiLocationApp.countryOfBirth.home.createOrEditLabel" data-cy="CountryOfBirthCreateUpdateHeading">
            <Translate contentKey="apiLocationApp.countryOfBirth.home.createOrEditLabel">Create or edit a CountryOfBirth</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="country-of-birth-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('apiLocationApp.countryOfBirth.geographicLevel')}
                id="country-of-birth-geographicLevel"
                name="geographicLevel"
                data-cy="geographicLevel"
                type="select"
              >
                {geographicLevelValues.map(geographicLevel => (
                  <option value={geographicLevel} key={geographicLevel}>
                    {translate(`apiLocationApp.GeographicLevel.${geographicLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('apiLocationApp.countryOfBirth.date')}
                id="country-of-birth-date"
                name="date"
                data-cy="date"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.countryOfBirth.geography')}
                id="country-of-birth-geography"
                name="geography"
                data-cy="geography"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.countryOfBirth.geographyCode')}
                id="country-of-birth-geographyCode"
                name="geographyCode"
                data-cy="geographyCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.countryOfBirth.totalAllUsualResidents')}
                id="country-of-birth-totalAllUsualResidents"
                name="totalAllUsualResidents"
                data-cy="totalAllUsualResidents"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.countryOfBirth.ukTotal')}
                id="country-of-birth-ukTotal"
                name="ukTotal"
                data-cy="ukTotal"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.countryOfBirth.england')}
                id="country-of-birth-england"
                name="england"
                data-cy="england"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.countryOfBirth.northernIreland')}
                id="country-of-birth-northernIreland"
                name="northernIreland"
                data-cy="northernIreland"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.countryOfBirth.scotland')}
                id="country-of-birth-scotland"
                name="scotland"
                data-cy="scotland"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.countryOfBirth.wales')}
                id="country-of-birth-wales"
                name="wales"
                data-cy="wales"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.countryOfBirth.republicOfIreland')}
                id="country-of-birth-republicOfIreland"
                name="republicOfIreland"
                data-cy="republicOfIreland"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.countryOfBirth.otherEuCountries')}
                id="country-of-birth-otherEuCountries"
                name="otherEuCountries"
                data-cy="otherEuCountries"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.countryOfBirth.africa')}
                id="country-of-birth-africa"
                name="africa"
                data-cy="africa"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.countryOfBirth.middleEastAsia')}
                id="country-of-birth-middleEastAsia"
                name="middleEastAsia"
                data-cy="middleEastAsia"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.countryOfBirth.farEast')}
                id="country-of-birth-farEast"
                name="farEast"
                data-cy="farEast"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.countryOfBirth.theAmericas')}
                id="country-of-birth-theAmericas"
                name="theAmericas"
                data-cy="theAmericas"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.countryOfBirth.antarcticaOceania')}
                id="country-of-birth-antarcticaOceania"
                name="antarcticaOceania"
                data-cy="antarcticaOceania"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.countryOfBirth.otherCountries')}
                id="country-of-birth-otherCountries"
                name="otherCountries"
                data-cy="otherCountries"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/country-of-birth" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CountryOfBirthUpdate;
